// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Home: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M21.424 9.974 12.6 2.229a.896.896 0 0 0-1.207.001L8.047 5.211V4.395a.95.95 0 0 0-.93-.949H4.326a.95.95 0 0 0-.931.949v.017-.001 4.67l-.918.953c-.295.31-.477.731-.477 1.194v9.137c0 .906.725 1.642 1.627 1.661h16.746a1.661 1.661 0 0 0 1.628-1.661v-.03.001-9.08c0-.509-.222-.967-.574-1.281l-.002-.001h-.001Zm-8.261 4.814V20.1h-2.326v-5.312h2.326Zm.93-1.93H9.907a.95.95 0 0 0-.93.949v.017-.001V20.1H3.86v-8.772l1.123-1.165a.976.976 0 0 0 .273-.678V5.38h.93V7.315c0 .38.218.708.535.868l.006.003a.897.897 0 0 0 1.001-.144l-.001.001L12 4.234l8.136 7.141V20.1h-5.113v-6.293a.95.95 0 0 0-.929-.949h-.001Z" />
  </SvgIcon>
);

Home.activeColor = 'inherit';
Home.muiName = 'Home';
